import React, { ComponentProps as CP } from 'react'

import T from 'components/FormattedMessage'
import MainLayout from 'components/MainLayout'
import InfoTab from './tabs/InfoTab'
import AchievementsTab from './tabs/AchievementsTab'

export interface Props {
  infoTab: CP<typeof InfoTab>
  achievementsTab: CP<typeof AchievementsTab>
}

class ProfileScreen extends React.Component<Props> {
  renderInfoTab = () => (
    <InfoTab {...this.props.infoTab} />
  )

  renderAchievementsTab = () => (
    <AchievementsTab {...this.props.achievementsTab} />
  )

  render() {
    return (
      <MainLayout
        tabs={[
          { title: <T id="root_tab_account" />, url: '/profile', component: this.renderInfoTab },
          { title: <T id="achievements_title" />, url: '/profile/achievements', component: this.renderAchievementsTab },
        ]}
      />
    )
  }
}

export default ProfileScreen
